import React, { ChangeEvent, useState } from "react";
import addToMailchimp from "gatsby-plugin-mailchimp";

interface ApiResponse {
	result: string;
	msg: string;
}

const Newsletter = () => {
	const [email, setEmail] = useState<string>("");
	const [data, setData] = useState<ApiResponse | undefined>(undefined);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		e.stopPropagation();

        const response: ApiResponse = await addToMailchimp(email);

		if (response.result === "success") setEmail("");

		setData(response);
	};

    const handleEmailInput = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setEmail(value.trim());
        setData(undefined);
    };

  return (
    <div className="flex flex-col items-center w-full">
        <form id="subscription-form" name="subscription-form" onSubmit={handleSubmit} className="px-4 w-full max-w-md">
            {/* Title */}
            <h1 className="mb-4 font-bold text-white text-2xl text-center">
                Subscribe to our newsletter
            </h1>
            {/* Email input and Submit button */}
            <div className="flex md:flex-row flex-col gap-2">
                <input
                    type="email"
                    id="email"
                    name="email"
                    className="flex-1 px-4 py-2 rounded-md focus:outline-none text-brand-gray1"
                    placeholder="Enter your email"
                    value={email}
                    required
                    onChange={handleEmailInput}
                />
                <button
                    type="submit"
                    className="bg-brand-green px-4 py-2 rounded-md font-semibold text-white"
                >
                    Subscribe
                </button>
            </div>
            {/* Message */}
            {data && (
                <div
                    className={`mt-4 p-2 text-center text-white rounded-md ${
                    data.result === "success" ? "bg-brand-green" : "bg-red-600"
                    }`}
                >
                    {data.msg}
                </div>
            )}
            {/* Subscription text */}
            <p className="mt-4 text-white text-center">
                By signing up, you agree to our{" "}
                <a href="https://dgital.com/privacy-policy" className="underline" target="_blank">
                    Privacy Policy
                </a>
                .
            </p>
        </form>
    </div>
  );
};

export default Newsletter;
